import { lazy, Suspense } from 'react';
import SEO from '@/components/SEO';
import Navigation from '../sections/Navigation';
import Hero from '../sections/Hero'; // Eagerly loaded — LCP element must render immediately
import LandSignalScore from '../sections/LandSignalScore';
const DashboardPreview = lazy(() => import('../sections/DashboardPreview'));
import ScoringBreakdown from '../sections/ScoringBreakdown';
import SampleParcelReportV2 from '../sections/SampleParcelReportV2';
const AICoverageIntelligence = lazy(() => import('../sections/AICoverageIntelligence'));
import Pricing from '../sections/Pricing';
import CompetitivePositioning from '../sections/CompetitivePositioning';
import FAQ from '../sections/FAQ';
import CTASection from '../sections/CTASection';
import Footer from '../sections/Footer';
import CookieConsent from '../sections/CookieConsent';
import useLenis from '../hooks/useLenis';
import { Toaster } from 'sonner';

const SectionLoader = () => (
  <div className="flex items-center justify-center py-20" style={{ background: '#07110D' }}>
    <div className="h-8 w-8 animate-spin rounded-full border-2 border-[#7CFF6B] border-t-transparent" />
  </div>
);

export default function Home() {
  useLenis();

  return (
    <>
      <SEO
        title="Parcel Lead Pro — Find Undervalued Land Before Everyone Else Does"
        description="Data-powered land intelligence for verified high-growth markets, beginning with South Carolina. Get wholesale offer ranges, growth analysis, and PLP Opportunity Scores for every parcel."
      />

      <Navigation />

      <main id="main-content">
        {/* 1. Hero — LCP element, eagerly loaded for immediate render */}
        <Hero />

        {/* 2. PLP Opportunity Score */}
        <div className="plp-section-dark">
          <LandSignalScore />
        </div>

        {/* 3. Dashboard Preview */}
        <div className="plp-section-dark">
          <Suspense fallback={<SectionLoader />}>
            <DashboardPreview />
          </Suspense>
        </div>

        {/* 4. AI Scoring Explanation */}
        <div className="plp-section-light">
          <ScoringBreakdown />
        </div>

        {/* 5. Sample Report */}
        <div className="plp-section-light">
          <SampleParcelReportV2 />
        </div>

        {/* 6. AI Coverage Intelligence */}
        <div className="plp-section-dark">
          <Suspense fallback={<SectionLoader />}>
            <AICoverageIntelligence />
          </Suspense>
        </div>

        {/* 7. Pricing */}
        <div className="plp-section-light">
          <Pricing />
        </div>

        {/* 8. Why Parcel Lead Pro */}
        <div className="plp-section-dark">
          <CompetitivePositioning />
        </div>

        {/* 9. FAQ */}
        <div className="plp-section-dark">
          <FAQ />
        </div>

        {/* 9. CTA */}
        <div className="plp-section-dark">
          <CTASection />
        </div>
      </main>

      <Footer />
      <CookieConsent />
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: '#101D29',
            border: '1px solid rgba(255,255,255,0.1)',
            color: '#fff',
          },
        }}
      />
    </>
  );
}
